var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowUp component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowUp extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.388 2.20419C12.2572 2.07345 12.0799 2 11.895 2C11.8746 2 11.8543 2.00089 11.8342 2.00266C11.6403 2.01803 11.4687 2.11274 11.3519 2.25432L2.20419 11.4021C1.93194 11.6743 1.93194 12.1157 2.20419 12.388C2.47645 12.6602 2.91787 12.6602 3.19012 12.388L11.1929 4.38524V21.0955C11.1929 21.4805 11.505 21.7926 11.89 21.7926C12.2751 21.7926 12.5872 21.4805 12.5872 21.0955V4.37526L20.5999 12.388C20.8721 12.6602 21.3135 12.6602 21.5858 12.388C21.8581 12.1157 21.8581 11.6743 21.5858 11.4021L12.388 2.20419Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowUp.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowUp.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowUp.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-up') === undefined) {
    customElements.define('cat-icon-arrow-up', BlocksIconArrowUp);
}
